<template>
  <div>
    <v-dialog v-model="value" persistent max-width="1010px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Importar alumnos</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 1" :step="1">Sube tu archivo</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 2" :step="2">
                    <span v-if="!working.validating">{{ modal.text }}</span>
                    <v-progress-circular v-else size="20" indeterminate color="primary"></v-progress-circular>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :step="3">Terminado</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content :step="1">
                    <v-card height="400px">
                      <v-card-title class="subheading">
                        Importa tu archivo Excel de tus alumnos como se muestra en el ejemplo.
                        <a
                          href="examples/lista_ejemplo_alumnos.xlsx"
                        >&nbsp;Descargar</a>
                      </v-card-title>
                      <v-layout row wrap justify-center>
                        <v-flex xs12 class="form-csv text-xs-center">
                          <input
                            @change="imageLoad($event)"
                            id="file_csv_student"
                            type="file"
                            accept=".xlsx"
                          />
                          <div class="csv-text">
                            <h4 class="center-align">Arrastra tu archivo Excel aquí</h4>
                            <h5 id="csv-success">
                              O
                              <u style="color:red;">
                                <span style="color:red;">selecciona</span>
                              </u> el archivo
                            </h5>
                          </div>
                        </v-flex>
                        <v-expand-transition>
                          <v-flex v-show="working.loading" mt-3 xs12 class="text-xs-center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-flex>
                        </v-expand-transition>
                        <v-expand-transition>
                          <v-flex v-show="flags.status == 200" mt-3 xs12 class="text-xs-center">
                            <v-icon style="vertical-align: bottom;" color="green">check</v-icon>Archivo válido
                          </v-flex>
                        </v-expand-transition>
                        <v-expand-transition>
                          <v-flex v-show="flags.status == 201" mt-3 xs12 class="text-xs-center">
                            <v-icon style="vertical-align: bottom;" color="orange">warning</v-icon>Archivo con registros erróneos pero aún importable
                          </v-flex>
                        </v-expand-transition>
                        <v-expand-transition>
                          <v-flex v-show="flags.status == 404" mt-3 xs12 class="text-xs-center">
                            <v-icon style="vertical-align: bottom;" color="red">clear</v-icon>El archivo no es válido
                          </v-flex>
                        </v-expand-transition>
                        <v-expand-transition>
                          <v-flex v-show="flags.status == 403" mt-3 xs12 class="text-xs-center">
                            <v-icon style="vertical-align: bottom;" color="red">clear</v-icon>El formato del archivo no es correcto; descarga el ejemplo para mayor información
                          </v-flex>
                        </v-expand-transition>
                      </v-layout>
                    </v-card>
                  </v-stepper-content>
                  <v-stepper-content :step="2">
                    <v-card height="400px">
                      <v-data-table
                        :headers="headers"
                        :items="errorItems"
                        :loading="working.validating"
                        rows-per-page-text="Registros por página"
                      >
                        <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        <template
                          v-slot:pageText="props"
                        >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
                        <template v-slot:headers="props">
                          <tr>
                            <th v-for="header of props.headers" :key="header.text">{{ header.text }}</th>
                          </tr>
                        </template>
                        <template v-slot:items="props">
                          <td v-if="flags.status != 200">
                            <v-edit-dialog :return-value.sync="props.item.Nombre" lazy>
                              {{ props.item.Nombre }}
                              <template v-slot:input>
                                <v-text-field v-model="props.item.Nombre" label="Nombre"></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td v-else>{{ props.item.Nombre }}</td>
                          <td v-if="flags.status != 200" class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.Apellidos" lazy>
                              {{ props.item.Apellidos }}
                              <template v-slot:input>
                                <v-text-field v-model="props.item.Apellidos" label="Apellidos"></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td v-else>{{ props.item.Apellidos }}</td>
                          <!-- <td v-if="flags.status == 200" class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.Genero" lazy>
                              {{ props.item.Genero | genderFilter }}
                              <template v-slot:input>
                                <v-text-field v-model="props.item.Genero" label="Género"></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>-->
                          <td>{{ props.item.Genero | genderFilter }}</td>
                          <td v-if="flags.status != 200" class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.Nivel" lazy>
                              {{ props.item.Nivel }}
                              <template v-slot:input>
                                <v-text-field v-model="props.item.Nivel" label="Nivel"></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td v-else>{{ props.item.Nivel }}</td>
                          <td v-if="flags.status != 200" class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.Grado" lazy>
                              {{ props.item.Grado }}
                              <template v-slot:input>
                                <v-text-field v-model="props.item.Grado" label="Grado"></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td v-else>{{ props.item.Grado }}</td>
                          <td v-if="flags.status != 200" class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.Grupo" lazy>
                              {{ props.item.Grupo }}
                              <template v-slot:input>
                                <v-text-field v-model="props.item.Grupo" label="Grupo"></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td v-else>{{ props.item.Grupo }}</td>
                          <td v-if="flags.status != 200" class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.Matricula" lazy>
                              {{ props.item.Matricula }}
                              <template v-slot:input>
                                <v-text-field v-model="props.item.Matricula" label="Matrícula"></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td v-else>{{ props.item.Matricula }}</td>
                          <td
                            v-if="excel2jsonFail.length > 0"
                            class="text-xs-right"
                          >{{ props.item.Error }}</td>
                          <td v-else></td>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-card>
                      <v-layout row wrap justify-center>
                        <v-flex xs12 class="text-xs-center">
                          <h1>{{ modal.title }}</h1>
                          <v-alert
                            style="border-radius: 33px;"
                            :value="true"
                            :type="flags.status == 201 ? 'warning': 'success'"
                          >{{ modal.message }}</v-alert>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="noButtons && e1 != 3" :disabled="e1 == 1" icon color="primary" @click="back">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="noButtons && e1 < 3" flat small @click="close">Cancelar</v-btn>
          <v-btn
            v-if="e1 == 2 && modal.text == 'Corrección de errores'"
            color="primary"
            small
            @click="next"
          >Validar</v-btn>
          <v-btn v-if="e1 == 3 && flags.status == 201" color="primary" @click="download">Descargar</v-btn>
          <v-btn v-if="e1 == 3" @click="close" flat>Terminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="noButtons && e1 != 3"
            :disabled="flags.continue"
            color="primary"
            icon
            @click="(e1 == 2) ? importAlways() : next()"
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { funciones } from "../../Mixins/Funciones";
export default {
  props: ["value", "mats"],
  mixins: [funciones],
  data: () => ({
    e1: 0,
    working: {
      loading: false,
      validating: false
    },
    levels: [],
    lAbbrs: [],
    flags: {
      continue: true,
      status: 0
    },
    modal: {
      text: "Verificación de contenido",
      title: "",
      message: ""
    },
    headers: [
      {
        text: "Nombre",
        align: "left",
        sortable: false,
        value: "Nombre"
      },
      { text: "Apellidos", sortable: false, value: "Apellidos" },
      { text: "Género", value: "gender", sortable: false },
      { text: "Nivel", value: "level" },
      { text: "Grado", sortable: false, value: "grade" },
      { text: "Grupo", sortable: false, value: "group" },
      { text: "Matrícula", sortable: false, value: "group" },
      { text: "Error", sortable: false, value: "Error" }
    ],
    errorItems: [],
    correctItems: [],
    report: [],
    noButtons: true
  }),
  filters: {
    genderFilter(value) {
      return value == "MALE" ? "Masculino" : "Femenino";
    }
  },
  mounted() {
    this.$store
      .dispatch("student/toolGetLevelsAndGGs")
      .then(response => {
        for (const [index, item] of response.data.entity.entries()) {
          this.levels[item.typeLevel.toLowerCase()] = [item.id];
          this.lAbbrs[item.abbr.toLowerCase()] = [item.id];
          var ggs = [];
          for (const [index2, gg] of item.ggs.entries()) {
            ggs[gg.grade.toLowerCase() + "" + gg.group.toLowerCase()] = gg.id;
          }
          this.levels[item.typeLevel.toLowerCase()][1] = ggs;
          this.lAbbrs[item.abbr.toLowerCase()][1] = ggs;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    imageLoad(event) {
      this.working.loading = true;
      this.processFile(event.target.files, event.target.value, "Alumnos", {
        levels: this.levels,
        mats: this.mats,
        abbrs: this.lAbbrs
      })
        .then(result => {
          this.working.loading = false;
          if (result == 200 || result == 201) {
            this.flags.status = result;
            this.flags.continue = false;
          }
        })
        .catch(err => {
          this.working.loading = false;
          if (this.excel2jsonFail.length < 15 && err != 403) {
            this.flags.status = 201;
            this.flags.continue = false;
          } else {
            this.flags.status = err;
            this.flags.continue = true;
          }
        });
    },
    next() {
      switch (this.e1) {
        case 1:
          this.e1 = 2;
          if (this.excel2jsonFail.length > 0) {
            this.errorItems = this.excel2jsonFail;
            this.modal.text = "Corrección de errores";
          } else {
            this.errorItems = this.excel2json;
          }
          this.$forceUpdate();
          break;
        case 2:
          this.excel2json = [];
          this.working.validating = true;
          var p = new Promise((resolve, reject) => {
            for (var r in this.errorItems) {
              this.excel2json.push(this.errorItems[r]);
            }
            this.validateExcel(resolve, reject, {
              levels: this.levels,
              mats: this.mats,
              abbrs: this.lAbbrs
            });
          })
            .then(result => {
              this.working.validating = false;
              if (result == 201) {
                this.modal.text = "Corrección de errores";
                this.errorItems = this.excel2jsonFail;
              } else {
                this.modal.text = "Verificación de contenido";
                this.errorItems = this.excel2json;
              }
              this.flags.status = result;
              this.$forceUpdate();
            })
            .catch(err => {
              this.working.validating = false;
            });
          break;
      }
    },
    importAlways() {
      this.working.validating = true;
      this.import();
    },
    import() {
      this.noButtons = false;
      var flag = 0;
      var allStds = [];
      for (var c in this.excel2json) {
        var student = {
          firstName: this.excel2json[c].Nombre,
          lastName: this.excel2json[c].Apellidos,
          gender: this.excel2json[c].Genero,
          level: this.excel2json[c].level,
          gg: this.excel2json[c].gg,
          personId: this.excel2json[c].Matricula
        };
        allStds.push(student);
      }
      var json = JSON.stringify(allStds);
      var obj = JSON.parse(json);
      this.$store
        .dispatch("student/importStudents", obj)
        .then(response => {
          this.report = response.data.entity;
          this.flags.status = 200;
          this.modal.title = "Importación exitosa";
          this.modal.message = "La lista fue importada correctamente";
          for (let r of this.report) {
            if (r.code != 200) {
              this.flags.status = 201;
              this.modal.title = "Advertencia";
              this.modal.message =
                "Algunos archivos no se pudieron importar, descarga el archivo para verificar los registros";
            }
          }
          this.noButtons = true;
          this.working.validating = false;
          this.e1 = 3;
        })
        .catch(error => {
          var obError = error.data.entity;
          console.log(obError);
          this.noButtons = true;
          this.working.validating = false;
          this.e1 = 3;
          this.flags.status = 201;
          this.modal.title = "Advertencia";
          this.modal.message =
            "Hubo un problema al importar la lista, intente de nuevo, por favor.";
        });
    },
    download() {
      var content = [];
      console.log(this.report);
      for (const [index, item] of this.report.entries()) {
        content.push({
          "Nombre-estudiante": item.entity.firstName,
          "Apellidos-estudiante": item.entity.lastName,
          Matrícula: item.entity.personId,
          Estado: item.message
        });
      }
      this.downloadReport(content);
    },
    back() {
      switch (this.e1) {
        case 2:
          this.e1 = 1;
          this.errorItems = [];
          this.$forceUpdate();
          break;
      }
    },
    close() {
      this.$emit("correct", this.correctItems);
      this.$emit("input", false);
      this.e1 = 1;
      this.excel2json = [];
      this.excel2jsonFail = [];
      this.badlist = false;
      this.errorCode = 0;
      this.flags.continue = true;
      this.flags.status = 0;
      document.getElementById("file_csv_student").value = "";
    }
  }
};
</script>

<style>
.form-csv input {
  position: absolute;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 190px;
  outline: none;
  opacity: 0;
}

.csv-text {
  margin-top: 10%;
}

.form-csv {
  height: 200px;
  border: 4px dashed #c6c7c7;
  background-color: #eceff0;
}
</style>

<style scoped>
td,
th {
  width: 119px;
  max-width: 119px;
  min-width: 119px;
}
</style>
